"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["autoFocus", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputClassName", "inputRef", "label", "message", "postfix", "prefix", "renderInput", "startAdornment", "style", "type", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextField = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TextField, _React$Component);

  var _super = _createSuper(TextField);

  function TextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextField);
    _this = _super.call(this, props);
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      // Set initial has-value state for uncontrolled component.
      hasUncontrolledValue: !!props.defaultValue,
      // Set initial active state for auto-focused component.
      isActive: props.autoFocus
    };
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "handleBlur",
    value: function handleBlur(event) {
      this.setState({
        isActive: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      // Pass value (instead of event object) to setState function
      // to prevent accidental closure around synthetic event object.
      var eventValue = event.target.value;
      this.setState(function (prevState, props) {
        // Setting a new state object causes a rerender.
        // Only set state if value has changed.
        var hasUncontrolledValue = props.value == null && eventValue;

        if (hasUncontrolledValue !== prevState.hasUncontrolledValue) {
          // Set has-value state for uncontrolled component.
          return {
            hasUncontrolledValue: hasUncontrolledValue
          };
        } // returning null will not set state nor rerender.


        return null;
      });

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      this.setState({
        isActive: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          disabled = _this$props.disabled,
          endAdornment = _this$props.endAdornment,
          error = _this$props.error,
          fullWidth = _this$props.fullWidth,
          id = _this$props.id,
          inputClassName = _this$props.inputClassName,
          inputRef = _this$props.inputRef,
          label = _this$props.label,
          message = _this$props.message,
          postfix = _this$props.postfix,
          prefix = _this$props.prefix,
          renderInput = _this$props.renderInput,
          startAdornment = _this$props.startAdornment,
          style = _this$props.style,
          type = _this$props.type,
          value = _this$props.value,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var _this$state = this.state,
          hasUncontrolledValue = _this$state.hasUncontrolledValue,
          isActive = _this$state.isActive;
      var classes = (0, _classnames.default)('ui-text-field', className, {
        'ui-text-field--active': isActive,
        'ui-text-field--disabled': disabled,
        'ui-text-field--error': error,
        'ui-text-field--full-width': fullWidth,
        'ui-text-field--has-value': hasUncontrolledValue || value,
        'ui-text-field--has-prefix': prefix,
        'ui-text-field--has-postfix': postfix
      });
      var inputClasses = (0, _classnames.default)('ui-text-field-input', inputClassName, {
        'ui-text-field--has-start-adorn': startAdornment,
        'ui-text-field--has-end-adorn': endAdornment
      });
      var labelClasses = (0, _classnames.default)('ui-text-field-label', {
        'ui-text-field--has-start-adorn': startAdornment,
        'ui-text-field--has-end-adorn': endAdornment
      });
      return (
        /*#__PURE__*/
        // <div className={parentClasses}>
        _react.default.createElement("label", {
          className: classes,
          htmlFor: id,
          style: style
        }, prefix ? /*#__PURE__*/_react.default.createElement("span", {
          className: "ui-text-field-prefix"
        }, prefix(this.props, this.state)) : null, startAdornment ? startAdornment(this.props, this.state) : null, /*#__PURE__*/_react.default.createElement("span", {
          className: labelClasses
        }, label), renderInput(_objectSpread(_objectSpread({}, otherProps), {}, {
          autoFocus: autoFocus,
          className: inputClasses,
          defaultValue: defaultValue,
          disabled: disabled,
          id: id,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          ref: inputRef,
          type: type,
          value: value
        })), endAdornment ? endAdornment(this.props, this.state) : null, /*#__PURE__*/_react.default.createElement("small", {
          className: "ui-text-field-message"
        }, message), postfix ? /*#__PURE__*/_react.default.createElement("span", {
          className: "ui-text-field-postfix"
        }, postfix(this.props, this.state)) : null) // </div>

      );
    }
  }]);
  return TextField;
}(_react.default.Component);

TextField.propTypes = {
  /** Focuses the input when mounted if `true`. */
  autoFocus: _propTypes.default.bool,

  /** Custom class name to add to TextField. */
  className: _propTypes.default.string,

  /** Default value for `input` (for uncontrolled components). */
  defaultValue: _propTypes.default.string,

  /** Disables TextField if `true`. */
  disabled: _propTypes.default.bool,

  /** Render function taking 2 params, (props, state) - this will be rendered inline with the input */
  endAdornment: _propTypes.default.func,

  /** Displays TextField in an error state if `true`. */
  error: _propTypes.default.bool,

  /** Sets the width of TextField to fill its container if `true`. */
  fullWidth: _propTypes.default.bool,

  /** ID attribute for `input`. Also sets the `htmlFor` attribute for `label`. */
  id: _propTypes.default.string,

  /** Custom class name to add to `input`. */
  inputClassName: _propTypes.default.string,

  /** Adds a ref callback to `input`. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /** Label displayed on (when inactive) or above (when active) `input`. */
  label: _propTypes.default.string,

  /** Message displayed below `input`. The message is typically hint text or error text. */
  message: _propTypes.default.string,

  /** Event handler called when `input` loses focus. */
  onBlur: _propTypes.default.func,

  /** Event handler called when `input` value changes. */
  onChange: _propTypes.default.func,

  /** Event handler called when `input` receives focus. */
  onFocus: _propTypes.default.func,

  /** A render function to be invoked to place an icon outside at the end of the input-line. (props, state) - this will be rendered after the input */
  postfix: _propTypes.default.func,

  /** A render function to be invoked to place an icon outside at the beginning of the input-line. (props, state) - this will be rendered before the input */
  prefix: _propTypes.default.func,

  /** Customizes how `input` is rendered. */
  renderInput: _propTypes.default.func,

  /** A render function to be invoked to place an icon inline at the beginning of the input-line. (props, state) - this will be rendered inline with the input */
  startAdornment: _propTypes.default.func,

  /** Adds inline styles to the TextField container. */
  style: _propTypes.default.object,

  /** Type attribute for `input`. */
  type: _propTypes.default.string,

  /** Value for `input` (for controlled components). */
  value: _propTypes.default.string
};
TextField.defaultProps = {
  renderInput: function renderInput(props) {
    return /*#__PURE__*/_react.default.createElement("input", props);
  },
  type: 'text'
};
var _default = TextField;
exports.default = _default;
//# sourceMappingURL=TextField.js.map